module.exports = "/fast-coin/img/coin/anim/in/coin_in_001.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_001.png
// module id = 2271
// module chunks = 5